/* eslint-disable import/max-dependencies */
import React from "react";
import { Skeleton } from "@mui/material";
import { withStyles } from "@mui/styles";

const LoadingIndicator = withStyles({
  root: {
    height: "120px",
    transform: "none",
  },
})(Skeleton);

const LoadingLinks = () => (
  <>
    {Array.from(
      {
        length: 6,
      },
      (v: void, k: number) => (
        <LoadingIndicator data-testid="loading" key={k} />
      )
    )}
  </>
);

export default LoadingLinks;
